import { render, staticRenderFns } from "./InvoiceAPHeader.vue?vue&type=template&id=5321a36c&"
import script from "./InvoiceAPHeader.vue?vue&type=script&lang=ts&"
export * from "./InvoiceAPHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5321a36c')) {
      api.createRecord('5321a36c', component.options)
    } else {
      api.reload('5321a36c', component.options)
    }
    module.hot.accept("./InvoiceAPHeader.vue?vue&type=template&id=5321a36c&", function () {
      api.rerender('5321a36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/invoices-ap/InvoiceAPHeader.vue"
export default component.exports